import Axios from "axios";
import ApiReq_NewNotice from "../types/ApiReq_NewNotice";
import axiosClient from "./axiosClient";

const BaseURL: string = process.env.REACT_APP_API_URL ?? "";

export default async function newNoticeService(
  bodyRequest: Partial<ApiReq_NewNotice>
) {
  try {
    const response = await axiosClient.post(`/notices/newNotice`, bodyRequest);

    if (response.status !== 200) {
      return null;
    }

    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export async function logViewAgencyInfo(
  bodyRequest: Partial<ApiReq_NewNotice>
) {
  try {
    const response = await axiosClient.post(
      `/notices/viewAgencyInfo`,
      bodyRequest
    );

    if (response.status !== 200) {
      return null;
    }

    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}
